import { useIdleTimer } from "react-idle-timer";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";

function IdleTimer(props) {
  const onIdle = () => {
    localStorage.clear();
    openNotification(
      "error",
      "SESSION EXPIRED",
      "Your session has expired. Please login again"
    );
    setTimeout(() => {
      window.onbeforeunload = null;
      window.location = process.env.REACT_APP_PROJECT_ROUTE !== "/null"
      ? process.env.REACT_APP_PROJECT_ROUTE
      : "/";
    }, 2500);
  };

  useIdleTimer({
    onIdle,
    timeout: props.minutes,
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    syncTimers: 0,
  });

  return null;
}

export default IdleTimer;
